import { render, staticRenderFns } from "./VoteItem.vue?vue&type=template&id=2f7d5854&"
import script from "./VoteItem.vue?vue&type=script&lang=js&"
export * from "./VoteItem.vue?vue&type=script&lang=js&"
import style0 from "./VoteItem.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports